module.exports = ".leftAvatar {\n    height: 70px !important;\n    width: 70px !important;\n    border-radius: 50%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/my-avatar/my-avatar.component.css
// module id = ./src/app/my-avatar/my-avatar.component.css
// module chunks = main